import React from 'react';
// Embeds the VF time zone provider
// eslint-disable-next-line no-restricted-imports
import { TimeZoneProvider as VizFrameworkTimeZoneProvider, TimeZoneProviderProps } from '@chronosphereio/viz-framework';
// Passes the user's time zone to the VF time zone picker
// eslint-disable-next-line no-restricted-imports
import { useUserTimeZone } from '@/context/UserTimePreferencesProvider';

export function TimeZoneProvider({
  initialTimeZone,
  disableURLParams = false,
  children,
}: Omit<TimeZoneProviderProps, 'userTimeZone'>) {
  const { timeZone } = useUserTimeZone();
  return (
    <VizFrameworkTimeZoneProvider
      userTimeZone={timeZone}
      initialTimeZone={initialTimeZone}
      disableURLParams={disableURLParams}
    >
      {children}
    </VizFrameworkTimeZoneProvider>
  );
}
